import { Style } from "@portal/lib/style/style";
import { Flex } from "../Flex/Flex";

export const FallbackStyledWrapper = Style("span", {});

export const MultiCurrencyBox = Style("div", {
  "&.title": {
    fontSize: "var(--fs-14)",
    color: "var(--gray-8)",
  },
  ".multi-currency-list": {
    borderTop: "1px solid var(--gray-8)",
    marginTop: "var(--space-4)",
    borderBottom: "1px solid var(--volcano-3)",
    marginBottom: "var(--space-8)",
  },
});

export const ExchangeIcon = Style(Flex, {
  width: "16px",
  height: "16px",
  padding: "1px 2px",
  background: "var(--geekblue-1)",
  border: "1px solid  var(--geekblue-1)",
  borderRadius: "var(--br-2)",
});
